module.exports = __webpack_public_path__ + "static/media/play-icon-playlist.557ebf09.svg";